export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://347wb0rryl.execute-api.us-west-2.amazonaws.com/prod"
  }
};
